import { base64SimpleLabelPDF } from "./simple-warning-label-generation";


export function base64SoldAsSetStickerPDF(widthInches: number, heightInches: number, copies: number = 1): string {
  const text = "SOLD AS SET\nDO NOT SEPARATE";

  return base64SimpleLabelPDF({
    widthInches: widthInches,
    heightInches: heightInches,
    text,
    copies,
  });
}
